import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  notifications: [],
  allNotifications: [],
  adminNotifications: [], // for storing admin notifications separately

};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setNotifications: (state, action) => {
      state.notifications = action.payload;
    },
    setAllNotifications: (state, action) => {
      state.allNotifications = action.payload;
    },
    addNotification: (state, action) => {
      state.notifications.unshift(action.payload);
      state.allNotifications.unshift(action.payload);
    },
    deleteNotification: (state, action) => {
      const id = action.payload;
      state.notifications = state.notifications.filter((n) => n.id !== id);
    },

setAdminNotifications: (state, action) => {
  state.adminNotifications = action.payload;
},
addAdminNotification: (state, action) => {
  state.adminNotifications.unshift(action.payload);
},
deleteAdminNotification: (state, action) => {
  const id = action.payload;
  state.adminNotifications = state.adminNotifications.filter((n) => n.id !== id);
},

  },
});

export const {
  setNotifications,
  setAllNotifications,
  addNotification,
  deleteNotification,
   setAdminNotifications,
  addAdminNotification,
  deleteAdminNotification, // 
} = notificationSlice.actions;

export default notificationSlice.reducer;
